;(() => {
  whenAvailable('nostojs', function () {
    nostojs(async (api) => {
      trackNostoClicks(api)
    })
  })

  function whenAvailable(name, callback) {
    window.setTimeout(function () {
      if (window[name]) {
        callback(window[name])
      } else {
        whenAvailable(name, callback)
      }
    }, 10)
  }

  function trackNostoClicks(nostoApi) {
    const nostoProductCardSelector = '#nosto-products a.product-card'
    const nostoProductCardObserver = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (
            node.nodeType === Node.ELEMENT_NODE &&
            node.matches(nostoProductCardSelector)
          ) {
            node.addEventListener('click', function () {
              const productId = node.getAttribute('data-product-id')
              const productUrl = node.getAttribute('data-product-url')
              const searchType = window.limely?.collectionId
                ? 'category'
                : 'serp'
              nostoApi.recordSearchClick(searchType, {
                productId: productId,
                url: productUrl
              })
            })
          }
        })
      })
    })

    //add event listener for any quick-view buttons added dynamically e.g. with Nosto
    nostoProductCardObserver.observe(document.body, {
      childList: true,
      subtree: true
    })
  }
})()
